import {
  QUERY_KEYS,
  soCaiColumns,
  thanhToanPhaiThuColumns,
  thueVatDauRaColumns,
  thueVatDauVaoColumns
} from '@/constants';
import { InfoDropdownV2, type InfoTableItem } from '@/components/custom/erp';

interface InfoProps {
  uuid: string;
  ma_ct?: string;
}

const tableItems: InfoTableItem[] = [
  { title: 'Xem sổ cái', endpoint: QUERY_KEYS.SO_CAI, columns: soCaiColumns, group: 1 },
  {
    title: 'Thanh toán phải thu',
    endpoint: QUERY_KEYS.THANH_TOAN_PHAI_THU,
    columns: thanhToanPhaiThuColumns,
    group: 1
  },
  { title: 'Thuế VAT đầu ra', endpoint: QUERY_KEYS.THUE_VAT_DAU_RA, columns: thueVatDauRaColumns, group: 1 },
  { title: 'Thuế VAT đầu vào', endpoint: QUERY_KEYS.THUE_VAT_DAU_VAO, columns: thueVatDauVaoColumns, group: 1 }
];

const InfoDropdown = ({ uuid, ma_ct }: InfoProps) => (
  <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} tableItems={tableItems} />
);

export default InfoDropdown;
